module.exports = __webpack_public_path__ + "static/record-d2305b8bcd6b26e0233e1c3d33f906c9.jpg";